<app-action-notification [showActionNotification]="showActionNotification"
  (showActionNotificationFalse)="clickShowActionNotification(false)"
(setAreThereNotifications)="setAreThereNotifications($event)"></app-action-notification>
<app-action-voice [show]="showActionVoice" (close)="showActionVoice = false"></app-action-voice>
<app-action-user [showActionUser]="showActionUser" (showActionUserFalse)="clickShowActionUser(false)"></app-action-user>
<header>
  <div class="header-menu">
      <div class="menu">
        <a (click)="clickRedirectHome()">
          <img [src]="logoSrc" alt="Logo da Empresa" class="logo-img" />
        </a>
        <app-mini-subheader [listSubperfil]="listSubperfil"></app-mini-subheader>
      </div>
      <div class="action">
        <!-- Botão do microfone ocultado a pedido -->
        @if (false && voiceSuportado && isErpContext) {
          <a (click)="openVoiceSettings()" [matTooltip]="micTooltip" [attr.aria-label]="micTooltip" class="mic-trigger action-icon">
            <span class="material-symbols-outlined large-icon" [class.mic-ativo]="isListening">{{ micIcon }}</span>
          </a>
        }
        <a (click)="clickShowActionNotification(null)" matTooltip="Notificações" aria-label="Notificações" class="action-icon">
          <span [matBadge]="areThereNotifications ? '!' : null" matBadgeColor="accent" matBadgeSize="small"
          matBadgeOverlap="false" class="material-symbols-outlined large-icon">notifications</span>
        </a>
        @if (updateAvailable) {
          <a (click)="openUpdateModal()"
            matTooltip="Atualização disponível — clique para ver detalhes"
            aria-label="Atualização disponível"
            class="update-btn-wrapper">
            <span class="material-symbols-outlined large-icon">system_update</span>
            <span class="update-pulse-dot"></span>
          </a>
        }
        <div class="avatar-env-wrapper">
          @if (envTag) {
            <div class="env-badge-overlay one-badge" [ngClass]="envTag === 'DEV' ? 'one-badge-success' : 'one-badge-warning'">
              {{ envTag }}
            </div>
          }
          <a (click)="clickShowActionUser(null)" matTooltip="Minha conta" aria-label="Minha conta" class="header-avatar-trigger">
            <span class="header-avatar">{{ userInitials }}</span>
          </a>
        </div>
    </div>
  </div>
</header>

<app-action-nav></app-action-nav>

<div [ngClass]="{'main-wrapper': true, 'has-footer': true}">
  @if (showSearch) {
    <app-search-bar [isCompact]="true"></app-search-bar>
  }
  <ng-content></ng-content>
</div>

<one-footer></one-footer>